import {IStation} from '../../../api/api.types';
import IOrganizationApi from '../../../api/organization-api.service';
import {IImomoErrorService} from '../../../error/error.service';
import {IStationApi} from '../../../api/station-api.service';

export default class ForecastBulletinController {
	static $inject = ['organizationApi', 'imomoErrorService', 'stationApi', '$window'];

	private bulletinLoadingInProgress: boolean = false;
	private bulletinUrl: string;
	private forecastBulletinSiteList: IStation[] = [];
	private forecastBulletinSiteListSearchText: string;

	constructor(
		private organizationApi: IOrganizationApi,
		private imomoErrorService: IImomoErrorService,
		private stationApi:IStationApi,
		private $window: ng.IWindowService
	) {

	}

	private onPrepareForecastBulletin() {
	  this.bulletinLoadingInProgress = true;
	  const siteIdList = _.map(this.forecastBulletinSiteList, (site) => {
	    return site.id;
	  });

	  this.organizationApi
	  	.generateForecastBulletin(Number.parseInt(this.$window.localStorage.getItem('currentOrgId')), siteIdList)
	      .then((data) => {
	        this.bulletinUrl = data;
	        this.bulletinLoadingInProgress = false;
	      })
	      .catch((error) => {
	        this.bulletinLoadingInProgress = false;
	        this.imomoErrorService.showErrorDetailsDialog(error.data.details);
	      })
	}

	queryStations() {
	  return this.stationApi.getDischargeStationsWithAcceptedForecast()
	    .then(data => {
	      return this.filterStationsByText(this.filterStationsBySelected(data));
	    });
	}

	onStationSelected(station: IStation) {
	  if (station) {
	    this.forecastBulletinSiteList.push(station);  
	  }

	  this.forecastBulletinSiteListSearchText = null;
	}

	unselectStation(station: IStation) {
	  this.forecastBulletinSiteList.splice(this.forecastBulletinSiteList.indexOf(station), 1);
	}

	filterStationsBySelected(fetchedStations: IStation[]) {
	  return _.filter(fetchedStations, (station) => {
	    let isItemSelected: boolean;
	    if (this.forecastBulletinSiteList) {
	      this.forecastBulletinSiteList.forEach((selectedStation) => {
	        if (!isItemSelected) {
	          isItemSelected = station.id === selectedStation.id;
	        }
	      });
	    }
	    return !isItemSelected;
	  });
	}

	filterStationsByText(stations: IStation[]) {
	  if (this.forecastBulletinSiteListSearchText) {
	    return _.filter(stations, (station) => {
	      return station.siteName.toLowerCase().indexOf(this.forecastBulletinSiteListSearchText.toLowerCase()) !== -1 || 
	          station.siteCode.indexOf(this.forecastBulletinSiteListSearchText) !== -1;
	    });
	  } else {
	    return stations;
	  }
	}
}


/** WEBPACK FOOTER **
 ** ./app/hydromet/forecasting/bulletin/forecast-bulletin.controller.ts
 **/